import { supabase } from '../services/supabaseClient';

export const getAnexoUrl = (bucketOrPath: string, maybePath?: string) => {
    const bucket = maybePath !== undefined ? bucketOrPath : 'anexos';
    const rawPath = maybePath !== undefined ? maybePath : bucketOrPath;
    if (!rawPath || typeof rawPath !== 'string') return '';
    if (/^https?:\/\//i.test(rawPath)) return rawPath;
    const { data } = supabase.storage.from(bucket).getPublicUrl(rawPath);
    return data.publicUrl;
};

export const uploadFile = async (bucket: string, path: string, file: File) => {
    const { data, error } = await supabase.storage
        .from(bucket)
        .upload(path, file, {
            cacheControl: '3600',
            upsert: true
        });

    if (error) throw error;
    return data;
};

export const getObraDocumentoUrl = async (caminho: string) => {
    const { data, error } = await supabase.storage
        .from('obra-documentos')
        .createSignedUrl(caminho, 3600); // Valid for 1 hour

    if (error) throw error;
    return data.signedUrl;
};
